<!-- 文章列表 -->
<template>
    <div v-if="componentsData.type == 7" class="bg-div"
            :style="componentsData.content.version ?
                {
                    ...(componentsData.content.bg_color && { backgroundColor: componentsData.content.bg_color }),
                    ...(componentsData.content.bg_img.picview && componentsData.content.bg_value && { backgroundImage: `url(${componentsData.content.bg_img.picview})` }),
                    padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                    margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                    borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`
                } : 
                `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
    >
        <div class="container">
            <div v-if="componentsData.content.style_value == 1" class="header flex-c" :style="`background: ${componentsData.content.title_bg_color};border-bottom: 1px solid ${componentsData.content.title_border_color};`">
                <div class="dec-left" :style="{ background: decLeft }"></div>
                <div class="dec-content fw-bold" :style="`color: ${componentsData.content.big_title_color};font-size: ${componentsData.content.size}px;`" >
                    {{ componentsData.content.title }}
                </div>
                <div class="dec-right" :style="{ background: decRight }"></div>
            </div>
            <div v-else class="header fw-bold" :style="`background: ${componentsData.content.title_bg_color};border-bottom: 1px solid ${componentsData.content.title_border_color};`">
                <span :style="`color: ${componentsData.content.big_title_color};font-size: ${componentsData.content.size}px;`" >
                    {{ componentsData.content.title }}
                </span>
            </div>
            <div v-for="(item, index) of componentsData.articleData" :key="index" class="box" >
                <div class="flex-sb">
                    <div class="flex-txt pb-3" :style="`color: ${componentsData.content.title_color};`" > {{ item.title }} </div>
                    <div v-if="componentsData.content.time_value" :style="`color: ${componentsData.content.time_color}`" > {{ item.created_at }} </div>
                </div>
                <div class="flex-txt" :style="`color: ${componentsData.content.text_color}`"> {{ item.content }} </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {
    },
    methods: {},
};
</script>

<style scoped>
.header {
    padding-bottom: 6px;
    border-bottom: 1px solid #ccc;
}
.box {
    padding: 6px 0;
    border-bottom: 1px solid #ccc;
}
.box:last-child {
    padding: 6px 0 0 0;
    border-bottom: none;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.flex-txt {
    font-size: 14px;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.fw-bold {
    font-weight: bold;
}
.pb-3 {
    padding-bottom: 3px;
}
</style>